import { useMemo } from 'react';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';

import {
  AllRingComplianceStatus,
  RingComplianceWithoutValidationStatus,
} from './data/types';

export const useFilterOptions = (showValidationStep: boolean) => {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site');

  const { t } = useTranslation();

  const getAvailableStatuses = (isValidatorActivated: boolean) => {
    return isValidatorActivated
      ? AllRingComplianceStatus
      : RingComplianceWithoutValidationStatus;
  };

  const statusOptions = useMemo(() => {
    return getAvailableStatuses(showValidationStep).map((status) => ({
      label: t(`qualityControl.ringComplianceReport.statusSearchable.state`, {
        context: status,
      }),
      value: status,
    }));
  }, [showValidationStep, t]);

  return {
    statusOptions,
  };
};
